/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
		this._scrollProgressCleanup = null;
	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				this.cleanupScrollProgress();
				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;
				}

				this.classList.add('product-recommendations--loaded');
				this.setupEvents();
				this.initMobileScrollProgress();

				setTimeout(() => {
					window.dispatchEvent(new Event('resize'));

					ScrollTrigger.batch('.animations-true .product-card .product-featured-image-link', {
						start: "top 90%",
						onEnter: (elements, triggers) => {
							gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
						}
					});
				});
			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		this.fetchProducts();
	}
	disconnectedCallback() {
		this.cleanupScrollProgress();
	}
	cleanupScrollProgress() {
		if (typeof this._scrollProgressCleanup === 'function') {
			this._scrollProgressCleanup();
			this._scrollProgressCleanup = null;
		}
	}
	/**
	 * Custom scroll progress bar on mobile (native overflow scroll cannot be styled reliably).
	 */
	initMobileScrollProgress() {
		this.cleanupScrollProgress();
		if (!this.classList.contains('swipe-on-mobile')) {
			return;
		}
		const scroller = this.querySelector('ul.products.row');
		if (!scroller) {
			return;
		}

		const progressEl = document.createElement('div');
		progressEl.className = 'product-recommendations__scroll-progress';
		progressEl.setAttribute('aria-hidden', 'true');
		progressEl.innerHTML =
			'<div class="product-recommendations__scroll-progress-track"><div class="product-recommendations__scroll-progress-thumb"></div></div>';
		scroller.insertAdjacentElement('afterend', progressEl);
		const thumb = progressEl.querySelector('.product-recommendations__scroll-progress-thumb');
		const mq = window.matchMedia('(max-width: 767px)');

		const update = () => {
			if (!mq.matches) {
				progressEl.setAttribute('hidden', '');
				return;
			}
			const { scrollLeft, scrollWidth, clientWidth } = scroller;
			const maxScroll = scrollWidth - clientWidth;
			if (maxScroll <= 1) {
				progressEl.setAttribute('hidden', '');
				return;
			}
			progressEl.removeAttribute('hidden');
			const thumbWidthPct = (clientWidth / scrollWidth) * 100;
			const leftPct = (scrollLeft / maxScroll) * (100 - thumbWidthPct);
			thumb.style.width = `${thumbWidthPct}%`;
			thumb.style.left = `${leftPct}%`;
		};

		let raf = 0;
		const onScroll = () => {
			if (raf) {
				cancelAnimationFrame(raf);
			}
			raf = requestAnimationFrame(update);
		};

		scroller.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', update);
		mq.addEventListener('change', update);
		const ro = new ResizeObserver(() => update());
		ro.observe(scroller);

		update();

		this._scrollProgressCleanup = () => {
			if (raf) {
				cancelAnimationFrame(raf);
			}
			scroller.removeEventListener('scroll', onScroll);
			window.removeEventListener('resize', update);
			mq.removeEventListener('change', update);
			ro.disconnect();
			if (progressEl.parentNode) {
				progressEl.remove();
			}
		};
	}
	setupEvents() {
		this.slideshow = Flickity.data(this.querySelector('slide-show'));
		this.prev = this.querySelector('.flickity-prev');
		this.next = this.querySelector('.flickity-next');

		if (this.next) {
			this.prev.addEventListener('click', () => this.navClick('prev'));
			this.next.addEventListener('click', () => this.navClick('next'));
		}
	}
	navClick(direction) {
		if (direction == 'prev') {
			this.slideshow.previous();
		} else {
			this.slideshow.next();
		}
	}

}

customElements.define('product-recommendations', ProductRecommendations);
